export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | undefined;
  label?: string | undefined;
  className?: string | undefined;
}

export function Spinner({
  size = 'md',
  label = 'Loading',
  className = '',
}: SpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3',
    xl: 'w-12 h-12 border-4',
  }[size];

  return (
    <div
      className={`animate-spin rounded-full border-slate-300/30 border-t-blue-500 ${sizeClasses} ${className}`}
      role="status"
      aria-label={label}
    >
      <span className="sr-only">{label}</span>
    </div>
  );
}
